import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';

// Experience Box Styling with Updated Colors
const ExperienceBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(3),
  backgroundColor: '#515669', // Updated background color
  borderRadius: '8px',
  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
  textAlign: 'center',
  color: 'white', // Set text color to white
  '&:hover': {
    transform: 'scale(1.05)', // Hover effect
  },
}));

// Flexbox container for Experience Section
const ExperienceContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: theme.spacing(3), // Spacing between experience boxes
  marginTop: theme.spacing(3), // Add some spacing at the top
}));

const Experience = () => {
  return (
    <Box sx={{ py: 6, px: 2 }}>
      {/* Heading */}
      <Typography
        variant="h4"
        sx={{
          textAlign: 'center',
          mb: 4,
          fontWeight: 'bold',
          color: '#333',
        }}
      >
        Experience
      </Typography>

      {/* Experience Section with Flexbox */}
      <ExperienceContainer>
        {/* iCanio Technologies */}
        <ExperienceBox sx={{ width: { xs: '100%', sm: '45%', md: '30%' } }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
            Icanio Technologies (2024)
          </Typography>
          <Typography variant="body1" sx={{ color: 'white' }}>
            Completed Internship
          </Typography>
        </ExperienceBox>

        {/* Exposys Datalabs */}
        <ExperienceBox sx={{ width: { xs: '100%', sm: '45%', md: '30%' } }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
            Exposys Datalabs (2023)
          </Typography>
          <Typography variant="body1" sx={{ color: 'white' }}>
            Completed Internship
          </Typography>
        </ExperienceBox>

        {/* E-Soft IT Solution */}
        <ExperienceBox sx={{ width: { xs: '100%', sm: '45%', md: '30%' } }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
            E-Soft IT Solution (2023)
          </Typography>
          <Typography variant="body1" sx={{ color: 'white' }}>
            Completed Internship
          </Typography>
        </ExperienceBox>
      </ExperienceContainer>
    </Box>
  );
};

export default Experience;

